<template>
  <div class="fybx-apply-container">
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
      <el-form
        :model="form"
        :rules="rules"
        :inline="false"
        ref="form"
        label-width="140px"
        label-position="right"
        v-loading="formLoading"
        element-loading-text="提交中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <!-- 申请人信息分割线已移除 -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="报销人姓名" prop="applyUserName">
              <el-input v-model="form.applyUserName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="报销时间" prop="applyDate">
              <el-date-picker
                v-model="form.applyDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :disabled="readonly"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="当前部门名称" prop="organName">
              <el-input v-model="form.organName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否借调" prop="isJd">
              <el-select
                v-model="form.isJd"
                placeholder="请选择"
                class="pctw100"
                @change="handleIsJdChange"
                :disabled="readonly"
              >
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.isJd === '1'">
            <el-form-item label="借调部门名称" prop="jdOrganName">
              <el-input
                v-model="form.jdOrganName"
                placeholder="请选择借调部门"
                readonly
                @focus="showJdOrganDialog"
                style="cursor: pointer"
                :disabled="readonly"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="showJdOrganDialog"
                  :disabled="readonly"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="所属项目编号" prop="ssxmCode" v-if="userType !== '2'">
              <el-input
                v-model="form.ssxmCode"
                placeholder="请选择项目"
                readonly
                @focus="showProjectDialog"
                style="cursor: pointer"
                :disabled="readonly"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="showProjectDialog"
                  :disabled="readonly"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属项目名称" prop="ssxmName" v-if="userType !== '2'">
              <el-input v-model="form.ssxmName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              :label="
                userType === '1'
                  ? '是否加签'
                  : userType === '3'
                  ? '是否有项目经理'
                  : '是否有直属领导'
              "
              prop="isPm"
            >
              <el-select
                v-model="form.isPm"
                placeholder="请选择"
                class="pctw100"
                @change="handleIsPmChange"
                :disabled="readonly"
              >
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.isPm === '1'">
            <el-form-item
              :label="userType === '1' ? '加签人' : userType === '3' ? '项目经理' : '直属领导'"
              prop="pmId"
            >
              <el-input
                v-model="form.pmName"
                :placeholder="
                  userType === '1'
                    ? '请选择加签人'
                    : userType === '3'
                    ? '请选择项目经理'
                    : '请选择直属领导'
                "
                readonly
                @focus="showPmDialog"
                style="cursor: pointer"
                :disabled="readonly"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="showPmDialog"
                  :disabled="readonly"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 添加抵扣相关表单字段 -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="抵扣金额" prop="dkje">
              <jh-number
                :decimalNumber="2"
                placeholder="抵扣金额"
                :isMoney="true"
                v-model="form.dkje"
                :disabled="readonly"
              >
                <span slot="append">元</span>
              </jh-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="应付金额" prop="yfAmt">
              <jh-number
                :decimalNumber="2"
                placeholder="应付金额"
                :isMoney="true"
                v-model="form.yfAmt"
                :disabled="true"
              >
                <span slot="append">元</span>
              </jh-number>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 项目经理选择弹窗 -->
        <el-dialog
          :title="
            userType === '1' ? '选择加签人' : userType === '3' ? '选择项目经理' : '选择直属领导'
          "
          width="80%"
          :visible.sync="dialogPm"
          :fullscreen="fullscreen"
          append-to-body
        >
          <users ref="pmUser" :onlyOne="true" />
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addPmOk">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 借调部门选择弹窗 -->
        <el-dialog
          title="选择借调部门"
          width="80%"
          :visible.sync="dialogJdOrgan"
          :fullscreen="fullscreen"
          append-to-body
        >
          <div class="organ-select-container">
            <el-input
              placeholder="输入关键字进行过滤"
              v-model="organFilterText"
              style="margin-bottom: 10px"
            ></el-input>
            <el-tree
              :data="organList"
              :props="organProps"
              :filter-node-method="filterOrganNode"
              node-key="id"
              ref="organTree"
              highlight-current
              @node-click="handleOrganNodeClick"
              style="height: 400px; overflow: auto"
            ></el-tree>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addJdOrganOk">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 项目选择弹窗 -->
        <el-dialog
          title="选择项目"
          width="80%"
          :visible.sync="dialogProject"
          :fullscreen="fullscreen"
          append-to-body
        >
          <XmList ref="xmList" @confirm="handleProjectConfirm" />
        </el-dialog>

        <!-- 发票选择弹窗 -->
        <el-dialog
          title="选择发票"
          width="90%"
          :visible.sync="dialogInvoice"
          :fullscreen="fullscreen"
          append-to-body
        >
          <FpList
            ref="fpList"
            :selectedFpIds="getAllSelectedFpIds()"
            :initialSelectedInvoices="
              currentSelectedDetail ? currentSelectedDetail.fpList || [] : []
            "
            @confirm="handleInvoiceConfirm"
            @cancel="handleInvoiceCancel"
          />
        </el-dialog>

        <!-- 发票列表查看弹窗 -->
        <el-dialog
          title="已选发票列表"
          width="80%"
          :visible.sync="dialogInvoiceList"
          :fullscreen="fullscreen"
          append-to-body
        >
          <el-table :data="currentInvoiceList" style="width: 100%">
            <el-table-column prop="fpNumber" label="发票号码" width="150"></el-table-column>
            <el-table-column prop="fpTypeName" label="发票类型" width="120"></el-table-column>
            <el-table-column prop="kpDate" label="开票日期" width="120">
              <template slot-scope="scope">
                {{ formatKpDate(scope.row.kpDate) }}
              </template>
            </el-table-column>
            <el-table-column prop="fpAmt" label="金额" width="120" align="right">
              <template slot-scope="scope"> {{ scope.row.fpAmt }}元 </template>
            </el-table-column>
            <el-table-column prop="gfName" label="购方名称" width="200"></el-table-column>
            <el-table-column prop="fpStatus" label="发票状态" width="100" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.fpStatus === '1'" type="success">未报销</el-tag>
                <el-tag v-else-if="scope.row.fpStatus === '2'" type="danger">报销中</el-tag>
                <el-tag v-else-if="scope.row.fpStatus === '3'" type="warning">已报销</el-tag>
                <span v-else>{{ scope.row.fpStatus || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="previewInvoice(scope.row)"> 预览 </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>

        <!-- 附件上传弹窗 -->
        <!-- 删除附件上传弹窗 -->

        <!-- 报销明细 -->
        <el-divider content-position="left">报销明细</el-divider>
        <!-- 移除添加明细按钮 -->

        <!-- 左右分栏布局 -->
        <el-row :gutter="0" class="table-container">
          <!-- 左侧：报销明细表格 -->
          <el-col :span="14" class="left-table">
            <div class="detail-section">
              <h4 class="section-title">报销明细列表</h4>
              <div class="content-box detail-content-box">
                <div class="content-box-table detail-table">
                  <el-table
                    :data="fybxMxList"
                    style="width: 100%"
                    @current-change="handleDetailRowChange"
                    highlight-current-row
                    row-key="fybxmx_id"
                    :row-class-name="getDetailRowClass"
                    :header-row-style="{ height: '40px' }"
                    :row-style="{ height: '40px' }"
                    border
                  >
                    <el-table-column prop="fsrq" label="发生日期" width="120">
                      <template slot-scope="scope">
                        <span>{{ scope.row.fsrq }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="fylxName" label="费用类型" width="120">
                      <template slot-scope="scope">
                        <span>{{ scope.row.fylxName || '-' }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="cwFylxName"
                      label="调整费用类型"
                      width="140"
                      v-if="finance"
                    >
                      <template slot-scope="scope">
                        <jh-enu-select
                          v-model="scope.row.cwFylx"
                          :valName.sync="scope.row.cwFylxName"
                          type="FYLX"
                          size="mini"
                          style="width: 100%"
                          class="finance-adjustment-select"
                        ></jh-enu-select>
                      </template>
                    </el-table-column>
                    <el-table-column prop="bxnr" label="报销内容" min-width="140">
                      <template slot-scope="scope">
                        <span>{{ scope.row.bxnr }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="amt" label="金额" width="200">
                      <template slot-scope="scope">
                        <jh-number
                          :decimalNumber="2"
                          placeholder="请输入金额"
                          :isMoney="true"
                          v-model="scope.row.amt"
                          size="mini"
                          style="width: 100%"
                          :disabled="true"
                        >
                          <span slot="append">元</span>
                        </jh-number>
                      </template>
                    </el-table-column>
                    <el-table-column prop="cwAmt" label="调整金额" width="200" v-if="finance">
                      <template slot-scope="scope">
                        <jh-number
                          :decimalNumber="2"
                          placeholder="请输入调整金额"
                          :isMoney="true"
                          v-model="scope.row.cwAmt"
                          size="mini"
                          style="width: 100%"
                          class="finance-adjustment-input"
                        >
                          <span slot="append">元</span>
                        </jh-number>
                      </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" min-width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.remark }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120" align="center">
                      <template slot-scope="scope">
                        <!-- 移除删除明细按钮和选择发票按钮 -->
                        <el-button
                          type="text"
                          size="mini"
                          @click="uploadAttachment(scope.$index)"
                          :disabled="!scope.row.fjList || scope.row.fjList.length === 0"
                          :style="{
                            color:
                              !scope.row.fjList || scope.row.fjList.length === 0
                                ? '#C0C4CC'
                                : '#409EFF'
                          }"
                        >
                          查看附件
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-col>

          <!-- 连接线组件 -->
          <el-col :span="2" class="connection-line-container">
            <connection-lines
              v-if="allDetailInvoices.length > 0"
              :leftDataList="getDetailsWithInvoices()"
              :rightDataList="allDetailInvoices"
              :relationField="'detailIndex'"
              ref="connectionLines"
            />
          </el-col>

          <!-- 右侧：发票列表表格 -->
          <el-col :span="8" class="right-table">
            <div class="invoice-section">
              <h4 class="section-title">发票列表</h4>
              <div class="content-box invoice-content-box">
                <div class="content-box-table invoice-table">
                  <el-table
                    :data="allDetailInvoices"
                    style="width: 100%"
                    v-loading="invoiceLoading"
                    border
                    size="mini"
                    row-key="fpId"
                    :row-class-name="getInvoiceRowClass"
                    :cell-style="{ textAlign: 'center' }"
                    :header-cell-style="{ textAlign: 'center', backgroundColor: '#f5f7fa' }"
                    :header-row-style="{ height: '40px' }"
                    :row-style="{ height: '40px' }"
                  >
                    <el-table-column prop="fpAmt" label="金额" min-width="90">
                      <template slot-scope="scope"> {{ scope.row.fpAmt }}元 </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="90">
                      <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="previewInvoice(scope.row)"
                          >预览</el-button
                        >
                        <!-- 移除删除发票按钮 -->
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div style="margin-top: 5px; text-align: center">
                <span class="invoice-summary">
                  发票：{{ allDetailInvoices.length }}张 / 总额：{{ allDetailTotalAmount }}元
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-tabs>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import XmList from '@/fpComponents/XmList.vue';
import FpList from '@/fpComponents/FpList.vue';
import ConnectionLines from '@/fpComponents/ConnectionLinesApply.vue'; // 引入 ConnectionLines 组件
import { bigDecimal as BigDecimal } from 'js-big-decimal';

export default {
  name: 'fybxApply',
  props: {
    // 是否只读模式
    readonly: {
      type: Boolean,
      default: false
    },
    // 是否首次加载
    isfirst: {
      type: Boolean,
      default: true
    },
    // 是否可编辑
    edit: {
      type: Boolean,
      default: true
    },
    // 实例ID
    instanceId: {
      type: String,
      default: ''
    },
    // 用户类型
    userType: {
      type: String,
      default: '3'
    },
    // 财务标识
    finance: {
      type: Boolean,
      default: false
    }
  },
  components: {
    XmList,
    FpList,
    ConnectionLines // 注册 ConnectionLines 组件
  },
  data() {
    return {
      form: {
        applyUserName: '',
        applyDate: dayjs().format('YYYY-MM-DD'),
        organCode: '',
        organName: '',
        isJd: '0',
        jdOrganCode: '',
        jdOrganName: '',
        ssxmCode: '',
        ssxmName: '',
        bxAmt: 0,
        isPm: '0',
        pmId: '',
        pmName: '',
        fybxId: '',
        jkje: 0, // 借款金额
        isDk: '0', // 是否抵扣（已移除界面）
        dkje: 0,
        yfAmt: 0
      },
      fybxMxList: [],
      rules: {
        bxAmt: [{ required: true, message: '请输入报销金额', trigger: 'blur' }],
        ssxmCode: [{ required: true, message: '请选择所属项目', trigger: 'change' }],
        jdOrganCode: [{ required: true, message: '请选择借调部门', trigger: 'change' }]
      },
      activeTab: 'apply',
      formLoading: false,
      dialogPm: false,
      dialogJdOrgan: false,
      dialogProject: false,
      dialogInvoice: false,
      dialogInvoiceList: false,
      fullscreen: false,
      organFilterText: '',
      organList: [],
      organProps: {
        label: 'organName',
        children: 'children'
      },
      currentInvoiceList: [],
      currentDetailIndex: -1, // 当前操作的明细索引
      invoiceLoading: false, // 发票列表加载状态
      currentSelectedDetail: null // 当前选中的报销明细
    };
  },
  computed: {
    // 获取所有明细的发票列表
    allDetailInvoices() {
      const allInvoices = [];
      this.fybxMxList.forEach((detail, index) => {
        if (detail.fpList && detail.fpList.length > 0) {
          // 确保每个发票都有正确的detailIndex
          const invoicesWithIndex = detail.fpList.map((fp) => ({
            ...fp,
            detailIndex: index
          }));
          allInvoices.push(...invoicesWithIndex);
        }
      });
      return allInvoices;
    },
    // 计算所有发票的总金额（高精度）
    allDetailTotalAmount() {
      let total = new BigDecimal('0');
      this.allDetailInvoices.forEach((invoice) => {
        total = total.add(new BigDecimal(String(invoice.fpAmt || '0')));
      });
      return Number(total.getValue());
    }
  },
  methods: {
    // 格式化开票日期
    formatKpDate(kpDate) {
      if (!kpDate) return '-';
      return dayjs(kpDate).format('YYYY-MM-DD');
    },
    getFileExtensionWithDot(filename) {
      if (!filename) return '';
      const lastDotIndex = filename.lastIndexOf('.');
      return lastDotIndex === -1 ? '' : filename.substring(lastDotIndex).toLowerCase();
    },
    // 初始化业务信息
    initBizInfo() {
      if (!this.instanceId) return;
      // 获取流程表单数据
      this.$api
        .post('/api/cwgl/fybx/flow/apply/getBizInfo', {
          instanceId: this.instanceId
        })
        .then((res) => {
          if (res.retHead && res.retHead.code === '0000000' && res.retBody) {
            // 初始化表单数据
            this.initFormData(res.retBody);
          } else {
            console.error('获取数据失败:', res.retHead?.message || '未知错误');
            this.$message.error('获取数据失败');
          }
        });
    },
    // 初始化方法
    init() {
      // 通过接口获取用户信息
      this.$api.get('/api/major/cwgl/fybx/userInfo').then((res) => {
        if (res && res.retHead.code === '0000000') {
          this.form.fybxId = res.retBody.fybxId || '';
          this.form.applyUserName = res.retBody.realName || '';
          this.form.organCode = res.retBody.organCode || '';
          this.form.organName = res.retBody.organFullName || '';
        }
      });

      // 获取部门列表
      this.$api.formPost('/api/major/common/doGetAllOrganJson', {}).then((res) => {
        if (res && res.retHead.code === '0000000') {
          this.organList = res.retBody || [];
        }
      });
    },

    // 初始化表单数据
    initFormData(data) {
      // 设置基本信息
      this.form = {
        applyUserName: data.applyUserName || this.form.applyUserName,
        applyDate: data.applyDate || dayjs().format('YYYY-MM-DD'),
        organCode: data.organCode || this.form.organCode,
        organName: data.organName || this.form.organName,
        isJd: data.isJd || '0',
        jdOrganCode: data.jdOrganCode || '',
        jdOrganName: data.jdOrganName || '',
        ssxmCode: data.ssxmCode || '',
        ssxmName: data.ssxmName || '',
        bxAmt: data.bxAmt || 0,
        isPm: data.isPm || '0',
        pmId: data.pmId || '',
        pmName: data.pmName || '',
        ywlsh: data.ywlsh || '',
        fybxId: data.fybxId || '',
        jkje: data.jkje || 0, // 借款金额
        isDk: data.isDk || '0', // 是否抵扣（已移除界面）
        dkje: data.dkje || 0,
        yfAmt: (() => {
          const bx = new BigDecimal(String(data.bxAmt || '0'));
          const dk = new BigDecimal(String(data.dkje || '0'));
          const yf = bx.subtract(dk);
          return Number(Number(yf.getValue()).toFixed(2));
        })()
      };

      // 设置明细列表
      this.fybxMxList = data.fybxMxList || [];
      // 初始化后计算应付金额
      this.recalcYfAmt();
      // 数据渲染后刷新连接线（适配新数据）
      this.$nextTick(() => {
        setTimeout(() => {
          this.updateConnectionLines();
        }, 300);
      });
    },

    handleIsJdChange(value) {
      if (value === '0') {
        this.form.jdOrganCode = '';
        this.form.jdOrganName = '';
      }
    },
    handleJdOrganChange(value) {
      const selectedDept = this.jdOrganOptions.find((item) => item.value === value);
      if (selectedDept) {
        this.form.jdOrganName = selectedDept.label;
      }
    },
    handleIsPmChange(value) {
      if (value === '0') {
        this.form.pmId = '';
        this.form.pmName = '';
      }
    },
    // 窗口大小变化处理
    onWindowResize() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.updateConnectionLines();
        }, 200);
      });
    },
    // 更新连接线方法
    updateConnectionLines() {
      if (this.$refs.connectionLines) {
        // 只有当有发票时才重新绘制连接线
        if (this.allDetailInvoices.length > 0) {
          this.$refs.connectionLines.drawConnectionLines();
        }
      }
    },
    // 获取明细行的类名
    getDetailRowClass({ row, rowIndex }) {
      // 返回明细索引作为类名，用于连接线
      return `detail-${rowIndex}`;
    },
    // 获取发票行的类名
    getInvoiceRowClass({ row, rowIndex }) {
      // 使用关联的明细索引作为类名，用于连接线
      if (!row) return `detail-${rowIndex}`;
      const detailIndex = typeof row.detailIndex === 'number' ? row.detailIndex : rowIndex;
      return `detail-${detailIndex}`;
    },
    // 明细行变化处理
    handleDetailRowChange(val) {
      this.currentSelectedDetail = val;
      if (val) {
        const index = this.fybxMxList.indexOf(val);
        this.currentDetailIndex = index;
        // 更新连接线
        this.$nextTick(() => {
          this.updateConnectionLines();
        });
      } else {
        this.currentDetailIndex = -1;
      }
    },
    // 添加明细
    addDetail() {
      const newDetail = {
        fybxmx_id: this.generateId(),
        fsrq: dayjs().format('YYYY-MM-DD'),
        bxnr: '',
        amt: 0,
        remark: '',
        fpList: [] // 新增发票列表
      };
      this.fybxMxList.push(newDetail);
      // 如果当前没有选中明细，则选中新添加的明细
      if (!this.currentSelectedDetail) {
        this.currentSelectedDetail = newDetail;
        this.currentDetailIndex = this.fybxMxList.length - 1;
      }
    },
    // 生成唯一ID
    generateId() {
      return 'mx_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    },
    // 移除明细
    removeDetail(index) {
      this.fybxMxList.splice(index, 1);
      this.currentSelectedDetail = null; // 删除明细后清空选中
      // 更新连接线
      this.$nextTick(() => {
        this.updateConnectionLines();
      });
    },
    // 选择发票
    selectInvoice(index) {
      this.currentDetailIndex = index;
      this.currentSelectedDetail = this.fybxMxList[index];
      this.dialogInvoice = true;
    },
    // 发票确认选择（使用高精度计算明细金额）
    handleInvoiceConfirm(selectedInvoices) {
      if (selectedInvoices && selectedInvoices.length > 0) {
        if (this.currentDetailIndex >= 0) {
          // 映射发票数据字段，确保后端能正确接收
          const mappedInvoices = selectedInvoices.map((invoice) => ({
            fpId: invoice.fpid,
            fpNumber: invoice.fpNumber,
            fpAmt: invoice.amtSum,
            kpDate: invoice.kpRq,
            fpTypeName: invoice.fpTypeName,
            gfName: invoice.gfName,
            fpStatus: invoice.fpStatus,
            fileId: invoice.fileId,
            fpName: invoice.fpName,
            detailIndex: this.currentDetailIndex // 添加关联的明细索引，用于连接线
          }));

          // 将新选择的发票添加到当前明细的发票列表中
          this.fybxMxList[this.currentDetailIndex].fpList = mappedInvoices;

          // 计算总金额（高精度）
          let totalAmount = new BigDecimal('0');
          mappedInvoices.forEach((invoice) => {
            totalAmount = totalAmount.add(new BigDecimal(String(invoice.fpAmt || '0')));
          });
          this.fybxMxList[this.currentDetailIndex].amt = Number(totalAmount.getValue());

          // 更新连接线
          this.$nextTick(() => {
            // 确保DOM已更新
            setTimeout(() => {
              this.updateConnectionLines();
            }, 300);
          });
        }
        this.dialogInvoice = false;
      }
    },
    // 发票取消选择
    handleInvoiceCancel() {
      this.dialogInvoice = false;
    },
    // 移除发票
    removeInvoice(index) {
      // 获取要删除的发票
      const invoiceToRemove = this.allDetailInvoices[index];
      if (invoiceToRemove && typeof invoiceToRemove.detailIndex === 'number') {
        const detailIndex = invoiceToRemove.detailIndex;
        // 找到对应的明细
        if (detailIndex >= 0 && detailIndex < this.fybxMxList.length) {
          // 找到发票在明细发票列表中的索引
          const fpIndex = this.fybxMxList[detailIndex].fpList.findIndex(
            (fp) => fp.fpId === invoiceToRemove.fpId
          );
          if (fpIndex >= 0) {
            // 从明细的发票列表中删除
            this.fybxMxList[detailIndex].fpList.splice(fpIndex, 1);
            // 更新明细金额
            this.updateDetailAmount(detailIndex);
            // 更新连接线
            this.$nextTick(() => {
              this.updateConnectionLines();
            });
          }
        }
      }
    },
    // 打开查看附件（回显已存在附件到上传控件）
    uploadAttachment(index) {
      this.currentDetailIndex = index;
      const detail = this.fybxMxList[index] || {};
      const fjList = Array.isArray(detail.fjList) ? detail.fjList : [];

      if (!fjList.length) {
        this.$message.warning('未找到相关附件信息');
        return;
      }
      // 准备预览文件数据
      const previewFiles = fjList.map((f) => ({
        label: f.name,
        id: f.fileId,
        url:
          this.getGlobalConfig().uploadURL +
          '/api/file/downloadFile' +
          '?fullfilename=' +
          f.fileId +
          this.getFileExtensionWithDot(f.name) +
          '&fileHashOrWholeFileId=' +
          f.fileId
      }));

      // 设置预览文件数据到 sessionStorage
      window.sessionStorage.previewFileData = JSON.stringify(previewFiles);

      // 左侧配置项 同elementUI tree组件
      window.sessionStorage.defaultProps = JSON.stringify({
        children: 'children',
        label: 'label'
      });

      // 当前高亮的文件（默认第一个）
      window.sessionStorage.currentFile = previewFiles[0]?.id;

      // 打开预览页面
      window.open(
        window.location.origin +
          (window.location.pathname ? window.location.pathname : '') +
          '#/previewFile?timestamp=' +
          new Date().getTime()
      );
    },
    // 预览附件
    previewAttachment(file) {
      if (!file.fileId) {
        this.$message.warning('附件文件ID不存在，无法预览');
        return;
      }
      const previewFile = {
        label: file.aliases,
        id: file.fileId,
        url:
          this.getGlobalConfig().uploadURL +
          '/api/file/downloadFile' +
          '?fullfilename=' +
          file.fileId +
          this.getFileExtensionWithDot(file.aliases) +
          '&fileHashOrWholeFileId=' +
          file.fileId
      };
      window.sessionStorage.previewFileData = JSON.stringify([previewFile]);
      window.sessionStorage.defaultProps = JSON.stringify({
        children: 'children',
        label: 'label'
      });
      window.sessionStorage.currentFile = file.fileId;
      window.open(
        window.location.origin +
          (window.location.pathname ? window.location.pathname : '') +
          '#/previewFile?timestamp=' +
          new Date().getTime()
      );
    },
    // 格式化文件大小
    formatFileSize(size) {
      if (size === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(size) / Math.log(k));
      return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    // 更新明细金额（高精度）
    updateDetailAmount(detailIndex) {
      if (detailIndex >= 0 && detailIndex < this.fybxMxList.length) {
        const detail = this.fybxMxList[detailIndex];
        let totalAmount = new BigDecimal('0');
        (detail.fpList || []).forEach((fp) => {
          totalAmount = totalAmount.add(new BigDecimal(String(fp.fpAmt || '0')));
        });
        this.fybxMxList[detailIndex].amt = Number(totalAmount.getValue());
      }
    },
    // 获取所有已选择的发票ID
    getAllSelectedFpIds() {
      const selectedFpIds = [];
      this.fybxMxList.forEach((detail, detailIndex) => {
        // 排除当前正在编辑的明细
        if (detailIndex !== this.currentDetailIndex && detail.fpList && detail.fpList.length > 0) {
          detail.fpList.forEach((fp) => {
            if (fp.fpId) {
              selectedFpIds.push(fp.fpId);
            }
          });
        }
      });
      return selectedFpIds;
    },
    // 预览发票
    previewInvoice(invoice) {
      if (!invoice.fileId) {
        this.$message.warning('发票文件ID不存在，无法预览');
        return;
      }

      // 获取行程单信息
      this.getXcdByFpIds([invoice.fpId]).then((xcdList) => {
        // 构建预览文件列表，包含发票和行程单
        const previewFiles = [];

        // 添加发票文件
        const invoiceFile = {
          label: invoice.aliases || '发票',
          id: invoice.fileId,
          url:
            this.getGlobalConfig().uploadURL +
            '/api/file/downloadFile' +
            '?fullfilename=' +
            invoice.fileId +
            this.getFileExtensionWithDot(invoice.aliases) +
            '&fileHashOrWholeFileId=' +
            invoice.fileId
        };
        previewFiles.push(invoiceFile);

        // 添加行程单文件
        if (xcdList && xcdList.length > 0) {
          xcdList.forEach((xcd, index) => {
            if (xcd.fileId) {
              previewFiles.push({
                label: xcd.fileName || `行程单${index + 1}`,
                id: xcd.fileId,
                url:
                  this.getGlobalConfig().uploadURL +
                  '/api/file/downloadFile' +
                  '?fullfilename=' +
                  encodeURIComponent(xcd.fileName || '') +
                  '&fileHashOrWholeFileId=' +
                  xcd.fileId
              });
            }
          });
        }

        // 设置预览文件数据到 sessionStorage
        window.sessionStorage.previewFileData = JSON.stringify(previewFiles);

        // 左侧配置项 同elementUI tree组件
        window.sessionStorage.defaultProps = JSON.stringify({
          children: 'children',
          label: 'label'
        });

        // 当前高亮的文件（默认选中发票）
        window.sessionStorage.currentFile = invoice.fileId;

        // 打开预览页面
        window.open(
          window.location.origin +
            (window.location.pathname ? window.location.pathname : '') +
            '#/previewFile?timestamp=' +
            new Date().getTime()
        );
      });
    },
    // 显示发票列表弹窗
    showInvoiceListDialog(index) {
      this.currentInvoiceList = this.fybxMxList[index].fpList || [];
      this.dialogInvoiceList = true;
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form = {
        applyUserName: this.form.applyUserName,
        applyDate: dayjs().format('YYYY-MM-DD'),
        organCode: this.form.organCode,
        organName: this.form.organName,
        isJd: '0',
        jdOrganCode: '',
        jdOrganName: '',
        ssxmCode: '',
        ssxmName: '',
        bxAmt: 0,
        isPm: '0',
        pmId: '',
        pmName: '',
        jkje: 0, // 借款金额
        isDk: '0', // 是否抵扣
        dkje: 0,
        yfAmt: 0
      };
      this.fybxMxList = [];
      this.currentSelectedDetail = null; // 重置时清空选中
      this.currentDetailIndex = -1; // 重置时清空索引
      this.$nextTick(() => {
        this.updateConnectionLines(); // 重置后更新连接线
      });
    },
    showPmDialog() {
      this.dialogPm = true;
    },
    addPmOk() {
      const checkedUsers = this.$refs.pmUser.selectedTableData;
      if (!checkedUsers || checkedUsers.length === 0) {
        this.$message.warning('请选择项目经理');
        return;
      }
      if (checkedUsers.length > 1) {
        this.$message.warning('只能选择一个项目经理');
        return;
      }
      const selectedUser = checkedUsers[0];
      this.form.pmId = selectedUser.id;
      this.form.pmName = selectedUser.realName;
      this.dialogPm = false;
    },
    showJdOrganDialog() {
      this.dialogJdOrgan = true;
      this.organFilterText = ''; // 清空过滤文本
      this.$nextTick(() => {
        this.$refs.organTree.filter(''); // 清空树的过滤
      });
    },
    addJdOrganOk() {
      const selectedNode = this.$refs.organTree.getCurrentNode();
      if (!selectedNode) {
        this.$message.warning('请选择一个借调部门');
        return;
      }
      this.form.jdOrganCode = selectedNode.organCode;
      this.form.jdOrganName = selectedNode.organName;
      this.dialogJdOrgan = false;
    },
    showProjectDialog() {
      this.dialogProject = true;
    },
    handleProjectConfirm(selectedProjects) {
      if (selectedProjects && selectedProjects.length > 0) {
        const selectedProject = selectedProjects[0]; // 取第一个选中的项目
        this.form.ssxmCode = selectedProject.xmCode;
        this.form.ssxmName = selectedProject.xmName;
      }
      this.dialogProject = false;
    },
    filterOrganNode(value, data) {
      if (!value) return true;
      return data.organName.indexOf(value) !== -1;
    },
    handleOrganNodeClick(data) {
      this.organFilterText = ''; // 点击节点时清空过滤文本
    },
    handleTabClick(tab) {
      if (tab.paneName === 'list') {
        this.activeTab = 'list';
      } else {
        this.activeTab = 'apply';
        this.resetForm();
      }
    },

    // 获取表单数据
    getData() {
      let params = false;
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.fybxMxList.length === 0) {
            this.$message.error('请至少添加一条报销明细');
            return;
          }

          // 验证明细数据
          for (let i = 0; i < this.fybxMxList.length; i++) {
            const detail = this.fybxMxList[i];
            if (!detail.fsrq) {
              this.$message.error(`第${i + 1}条明细的发生日期不能为空`);
              return;
            }
            if (!detail.bxnr) {
              this.$message.error(`第${i + 1}条明细的报销内容不能为空`);
              return;
            }
            if (!detail.amt || detail.amt <= 0) {
              this.$message.error(`第${i + 1}条明细的金额必须大于0`);
              return;
            }
            if (!detail.fpList || detail.fpList.length === 0) {
              this.$message.error(`第${i + 1}条明细的发票数量不能为0`);
              return;
            }
          }
          // 高精度比较：报销金额不能大于发票金额
          const totalBD = new BigDecimal(String(this.allDetailTotalAmount || '0'));
          const bxAmtBD = new BigDecimal(String(this.form.bxAmt || '0'));
          if (bxAmtBD.compareTo(totalBD) === 1) {
            this.$message.error('报销金额不能大于发票金额');
            return;
          }
          console.log('form data', this.form);

          params = JSON.parse(
            JSON.stringify({
              ...this.form,
              fybxMxList: this.fybxMxList
            })
          );
        }
      });

      console.log('fybxApplyForm data:', params);
      return params;
    },
    // 获取包含发票的明细列表
    getDetailsWithInvoices() {
      const detailsWithInvoices = [];
      this.fybxMxList.forEach((detail, index) => {
        if (detail.fpList && detail.fpList.length > 0) {
          detailsWithInvoices.push({
            ...detail,
            detailIndex: index
          });
        }
      });
      return detailsWithInvoices;
    },
    // 计算应付金额（高精度）
    recalcYfAmt() {
      const bx = new BigDecimal(String(this.form.bxAmt || '0'));
      const dk = new BigDecimal(String(this.form.dkje || '0'));
      const yf = bx.subtract(dk);
      this.form.yfAmt = Number(Number(yf.getValue()).toFixed(2));
    },

    // 根据发票ID获取行程单信息
    getXcdByFpIds(fpIds) {
      // 参数校验
      if (!fpIds || (Array.isArray(fpIds) && fpIds.length === 0)) {
        this.$message.warning('发票ID不能为空');
        return Promise.reject(new Error('发票ID不能为空'));
      }

      // 统一处理为数组格式
      const fpIdArray = Array.isArray(fpIds) ? fpIds : [fpIds];

      // 过滤掉空值
      const validFpIds = fpIdArray.filter((id) => id && id.toString().trim());

      if (validFpIds.length === 0) {
        this.$message.warning('没有有效的发票ID');
        return Promise.reject(new Error('没有有效的发票ID'));
      }

      const params = {
        fpIds: validFpIds
      };

      return this.$api
        .formPost('/api/major/fpgl/xcd/doGetByFpId', params)
        .then((res) => {
          if (res && res.retHead && res.retHead.code === '0000000') {
            return res.retBody || [];
          } else {
            const errorMsg = (res && res.retHead && res.retHead.message) || '获取发票信息失败';
            this.$message.error(errorMsg);
            return Promise.reject(new Error(errorMsg));
          }
        })
        .catch((error) => {
          console.error('获取发票信息失败:', error);
          if (error.message !== '获取发票信息失败') {
            this.$message.error('获取发票信息失败，请稍后重试');
          }
          return Promise.reject(error);
        });
    },

    // 财务调整保存方法
    saveFinanceAdjustment() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.fybxMxList.length === 0) {
              this.$message.error('没有可保存的报销明细');
              reject(new Error('没有可保存的报销明细'));
              return;
            }
            this.formLoading = true;
            const submitData = {
              ...this.form,
              fybxMxList: this.fybxMxList,
              instanceId: this.instanceId
            };

            this.$api
              .post('/api/cwgl/fybx/finance/save', submitData)
              .then((res) => {
                this.formLoading = false;
                if (res.retHead && res.retHead.code === '0000000') {
                  this.$message.success('财务调整保存成功');
                  // 重新加载数据
                  this.initBizInfo();
                  resolve(res);
                } else {
                  this.$message.error(res.retHead?.message || '保存失败');
                  reject(new Error(res.retHead?.message || '保存失败'));
                }
              })
              .catch((error) => {
                console.error('保存失败:', error);
                this.formLoading = false;
                this.$message.error('保存失败，请稍后重试');
                reject(error);
              });
          } else {
            reject(new Error('表单验证失败'));
          }
        });
      });
    }
  },
  watch: {
    'form.bxAmt'(val) {
      this.recalcYfAmt();
    },
    'form.dkje'(val) {
      this.recalcYfAmt();
    },
    // 监听实例ID变化，自动拉取详情数据
    instanceId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.initBizInfo();
        }
      }
    }
  },
  mounted() {
    // 初始化连接线
    this.$nextTick(() => {
      setTimeout(() => {
        this.updateConnectionLines();
      }, 500);
    });

    // 监听窗口大小变化，更新连接线
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.onWindowResize);
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/connection-lines.scss';

.el-divider__text {
  color: #409eff !important;
  font-weight: bold;
  font-size: 16px;
}

.pctw100 {
  width: 100%;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-row {
  margin-bottom: 20px;
}

.organ-select-container {
  padding: 10px;
}

.detail-section {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px 15px 15px 15px;
  background-color: #f9fafc;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.invoice-section {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px 5px 15px 5px;
  background-color: #f9fafc;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 统一标题样式 */
.section-title {
  margin-top: 0;
  margin-bottom: 10px; /* 减小标题与表格的间距 */
  font-size: 16px;
  color: #303133;
  height: 22px;
  line-height: 22px;
}

.invoice-summary {
  font-size: 12px;
  color: #606266;
}

/* 表格容器样式 */
.table-container {
  position: relative;
  display: flex;
  margin-bottom: 20px;
}

.left-table,
.right-table {
  position: relative;
}

.content-box {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content-box-table {
  flex-grow: 1;
  overflow-y: auto;
}

/* 连接线容器样式 */
.connection-line-container {
  position: relative;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  margin-top: 52px; /* 调整与表格头部对齐的高度 */
  width: 60px; /* 增加连接线容器宽度 */
  z-index: 5; /* 确保连接线显示在前面 */
  background-color: transparent !important;
}

/* 确保表格行高一致 */
::v-deep .el-table__row {
  height: 40px !important;
}

/* 确保表格头部高度一致 */
::v-deep .el-table__header tr {
  height: 40px !important;
}

/* 确保表格内容垂直居中 */
::v-deep .el-table__cell {
  vertical-align: middle;
  padding: 0 !important;
}

/* 表格基础样式 */
::v-deep .el-table td {
  padding: 0 !important;
}

::v-deep .el-table th,
::v-deep .el-table td {
  border: none;
}

/* 发票表格按钮样式 */
.invoice-table ::v-deep .el-button--text {
  padding: 2px 5px;
  margin: 0 2px;
}

/* 财务调整字段样式 */
::v-deep .finance-adjustment-select .el-input__inner {
  background-color: #fff7e6 !important; /* 浅橙色背景 */
  border-color: #ffcc99 !important;
}

::v-deep .finance-adjustment-select .el-input__inner:focus {
  background-color: #fff2cc !important;
  border-color: #ff9900 !important;
  box-shadow: 0 0 0 2px rgba(255, 153, 0, 0.2) !important;
}

::v-deep .finance-adjustment-input .el-input__inner {
  background-color: #f0f9ff !important; /* 浅蓝色背景 */
  border-color: #b3d9ff !important;
}

::v-deep .finance-adjustment-input .el-input__inner:focus {
  background-color: #e6f3ff !important;
  border-color: #4da6ff !important;
  box-shadow: 0 0 0 2px rgba(77, 166, 255, 0.2) !important;
}
</style>
